export { default } from './EditHoldDatesButton';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/EditHoldDatesButton/index.js